import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  //获取年份
  getYears({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/selectYearList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 拉取数据
  pullData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/pullData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //获取批次/科类
  getBatchNumAndSubject({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`baseScore/selectBatchAndSubjectOpt`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 列表查询
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/selectMainListData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出
  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  checkImportExcelNum({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/checkImportExcelNum`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导入
  importExcel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/importExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取版本
  selectVersion({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/selectVersionList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


  // 人工动分
  newPlanMatch({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/newPlanMatch`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //

  // 人工动分
  editData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/editData`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 新招计划做分
  autoEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/calculateScore`,params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 保存
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/saveData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 另存
  saveAs({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/saveAsData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 预览科类
  getSubjectPreview({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`calculate/getSubjectPreview`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 修改招生计划
  saveEnrollmentPlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/editEnrollmentPlan`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 计算累计人数
  peopleCount({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/peopleCount`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取空白智能分
  getBlankAiScore({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/getBlankAiScore`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 模型训练
  modelTraning({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/modelTraning`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 模型训练记录
  selectModelLog({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`train/selectModelLog`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 风险提示
  riskTips({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`calculate/riskTips`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
    // AI分数同步
    updateAiScore({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.post(`/calculate/updateAiScore`, params)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
      // 专业优化分同步
  updateProfessionalScore({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/calculate/updateProfessionalScore`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
